import { Dialog } from "primereact/dialog";
import { JVInput } from "../../../shared/JVInput";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { IAllRequirements } from "../../../models/AllRequirements";
import { IRequirementMast } from "../../../models/RequirementMast";
import { Fetch } from "../../../shared/Fetch";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import { InputText } from "primereact/inputtext";
import { IWebSite } from "../../../models/WebSite";

interface IProps {
    singleData: IAllRequirements,
    open: boolean,
    toast: any,
    loadTableData: () => void,
    HideSubNum: () => void,
}

const schema = yup.object({
    max_Submission: yup.number().nullable(),
});
interface ISubNum {
    max_Submission: number
}
let EmptyRequirement: ISubNum = {
    max_Submission: 0
};

export const IncreaseSub = (props: IProps) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IWebSite>, loading: boolean });
    const [loading, setLoading] = useState(false);
    const { control, handleSubmit, watch, formState: { errors }, reset, setValue } = useForm<ISubNum>({
        resolver: yupResolver(schema),
        defaultValues: EmptyRequirement,
        shouldFocusError: false
    });

    const saveToDB = async (data: any) => {
        setLoading(true);
        const response = await Fetch("Requirement_MAST/updateMaxSubmission", "POST", null, `req_id=${props.singleData.req_ID}&max_submission=${data.max_Submission}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', detail: "Added Successfully", life: 3000 });
            props.loadTableData();
            props.HideSubNum();
            setLoading(false);
        } else setLoading(false);
    }
    function onSubmit(data: IAllRequirements) {
        saveToDB(data);
    }
    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Website_Settings", "GET", null, ``, props.toast);
        if (response) {
            const data: Array<IWebSite> = await response.json();
            setTableData({ tableData: data, loading: false });

        }
    }

    useEffect(() => {
        if (props.open) {
            reset({ max_Submission: props.singleData.max_Submission });
            loadTableData();
        }
    }, [props.open]);

    return (
        <>
            <Dialog header="Increase Sub" visible={props.open} style={{ width: '30vw', height: "200" }} onHide={props.HideSubNum}>
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid flex">
                    <JVInput required column={3} label="Total Sub" control={control} name="max_Submission" />
                    <div className="field col-12 md:col-4">
                        <label >Default Sub</label>
                        <InputText disabled value={tableData?.tableData[0]?.no_Sub_Per_Req || 0} />
                    </div>
                    <div style={{ margin: '10px 0', width: '100%' }}></div>
                    <div className="col-12 md:col-12 flex justify-content-between">
                        <Button className="field col-12 md:col-4 h-2rem" style={{width: "49%"}} label="SAVE" type="submit" loading={loading}></Button>
                        <Button className="field col-12 md:col-4 p-button-outlined h-2rem" style={{width: "49%"}} label="CLOSE" onClick={props.HideSubNum} type="button"></Button>
                    </div>
                </form>
            </Dialog>
        </>
    );
};